<template>
  <form
    id="orderForm"
    novalidate="true"
    class="h-100"
  >
    <div class="decoration-choic h-100">
      

      <!-- <div class="col-container d-flex"> -->
        <div class="py-2 pb-2 mr-1 bg-light h-100">
          <h2 class="mb-0 py-2 text-center pt-3">Kontaktuppgifter</h2>
          <p class="py-2 text-center mb-2">Här fyller ni i kontaktuppgifterna som vi behöver för att ta emot er förfrågan. Var noga med att dubbelkolla så att ni fyller i rätt mailadress.</p>
          <h4 class="mb-1 mt-2">Beställare</h4>
            <div class="input-container mb-1">
              <label for="death_estate">Namn på dödsboet *</label>
              <input id="death_estate" v-model="value.death_estate">
              <p id="warning_death_estate" class="input-warning mt-1">Detta fält är obligatoriskt</p>
            </div>
            <div class="input-container mb-1">
              <label for="customer_name">Namn på beställaren / Begravningsbyrå *</label>
              <input id="customer_name" v-model="value.customer_name">
              <p id="warning_customer_name" class="input-warning mt-1">Detta fält är obligatoriskt</p>
            </div>
            <div class="input-container mb-1">
              <label for="shipping_address">Adress *</label>
              <input id="shipping_address" v-model="value.shipping_address">
              <p id="warning_shipping_address" class="input-warning mt-1">Detta fält är obligatoriskt</p>
            </div>
            <div class="input-split-container">
              <div class="input-container mb-1">
                <label for="shipping_zip">Postnummer *</label>
                <input id="shipping_zip" v-model="value.shipping_zip">
              <p id="warning_shipping_zip" class="input-warning mt-1">Detta fält är obligatoriskt</p>
              </div>
               <div class="input-container mb-1">
                <label for="shipping_city">Ort *</label>
                <input id="shipping_city" v-model="value.shipping_city">
              <p id="warning_shipping_city" class="input-warning mt-1">Detta fält är obligatoriskt</p>
              </div>
            </div>
            <div class="input-container mb-1">
              <label for="customer_phone">Telefonnummer *</label>
              <input id="customer_phone" type="tel" v-model="value.customer_phone">
              <p id="warning_customer_phone" class="input-warning mt-1">Detta fält är obligatoriskt</p>
            </div>
            <div class="input-container mb-1">
              <label for="customer_email">E-post *</label>
              <input id="customer_email" type="email" v-model="value.customer_email">
              <p id="warning_customer_email" class="input-warning mt-1">Ange en giltig e-postadress</p>
            </div>
          <h4 class="mb-1 mt-2">Fakturering</h4>
          <div class="input-container mb-1" style="flex-direction: row;">
            <input class="mr-05" type="checkbox" id="billing_same_as_customer" v-model="value.billing_same_as_customer">
            <label for="billing_same_as_customer">Faktureringsadress samma som beställare</label>
          </div>
          <template v-if="!value.billing_same_as_customer">
            
          <div class="input-container mb-1">
            <label for="billing_name">Namn *</label>
            <input id="billing_name" v-model="value.billing_name">
            <p id="warning_billing_name" class="input-warning mt-1">Detta fält är obligatoriskt</p>
          </div>
          <div class="input-container mb-1">
            <label for="billing_address">Faktura adress *</label>
            <input id="billing_address" v-model="value.billing_address">
            <p id="warning_billing_address" class="input-warning mt-1">Detta fält är obligatoriskt</p>
          </div>
          <div class="input-container mb-1">
            <label for="co_name">C/O Adress</label>
            <input id="co_name" v-model="value.co_name">
          </div>
          <div class="input-split-container">
            <div class="input-container mb-1">
              <label for="billing_zip">Faktura postnummer *</label>
              <input id="billing_zip" v-model="value.billing_zip">
              <p id="warning_billing_zip" class="input-warning mt-1">Detta fält är obligatoriskt</p>
            </div>
            <div class="input-container mb-1">
              <label for="billing_city">Faktura ort *</label>
              <input id="billing_city" v-model="value.billing_city">
              <p id="warning_billing_city" class="input-warning mt-1">Detta fält är obligatoriskt</p>
            </div>
          </div>
          <div class="input-container mb-1">
            <label for="billing_phone">Telefonnummer *</label>
            <input id="billing_phone" type="tel" v-model="value.billing_phone">
            <p id="warning_billing_phone" class="input-warning mt-1">Detta fält är obligatoriskt</p>
          </div>
          <div class="input-container mb-1">
            <label for="billing_email">E-post *</label>
            <input id="billing_email" type="email" v-model="value.billing_email">
            <p id="warning_billing_email" class="input-warning mt-1">Ange en giltig e-postadress</p>
          </div>
          </template>

          <h4 class="mb-1 mt-2">Övrigt</h4>
          <div class="input-split-container">
            <div class="input-container mb-1">
              <label for="graveyard">Kyrkogård *</label>
              <input id="graveyard" v-model="value.graveyard">
              <p id="warning_graveyard" class="input-warning mt-1">Detta fält är obligatoriskt</p>

            </div>
            <div class="input-container mb-1">
              <label for="gravestone_number">Gravnummer</label>
              <input id="gravestone_number" v-model="value.gravestone_number">
            </div>
          </div>
          <div class="input-container mb-1">
            <label for="other_information">Övrig information</label>
            <textarea id="other_information" v-model="value.other_information"></textarea>
          </div>



          <div class="selected-images-container input-container mb-1" style="flex-direction: row; flex-wrap: wrap;">
            <template v-for="(display_image, im) of display_images" :key="im + 'img'">
              <div class="item image-container">
                <img :src="display_image.src" :title="'image' + im" class="uploading-image" />
                <div class="close" @click="deleteImage(display_image)"></div>
              </div>
            </template>
          </div>

          <label style="display: block;" for="file-upload" class="button">
              Ladda upp bilder
          </label>
          <input style="display: none;" id="file-upload" type="file" accept=".jpg,.jpeg,.png" @change="uploadImage" />
          <p id="warning_images" class="input-warning mt-1">Bilden får inte var större än 2MB.</p>
        </div>
      <!-- </div> -->

      
      
 <!--      <div class="input-container mb-1" style="flex-direction: row;">
        <input class="mr-05" type="checkbox" id="accepted_conditions" v-model="value.accepted_conditions">
        <label for="accepted_conditions">Jag har läst och godkänner <a class="bold" href="#">villkoren</a></label>
      </div> -->
      <!-- <p id="warning_accepted_conditions" class="input-warning mt-1">Villkoren måste läsas och accepteras för att skicka förfrågan.</p> -->
    </div>
  </form>
</template>

<script>

  // billing_name
  // billing_phone
  // billing_email
import jQuery from 'jquery'

export default {
  name: 'OrderStep',
  props: {
      value: {
          type: Object,
          required: true
      },
      errors: {
          type: Array,
      },
      setImages: {
        type: Function
      },
  },
  watch: {
      value() {
          this.$emit('input', this.value);
      },
      errors() {
        console.log(this.errors);
        let requiredFields = ['death_estate','customer_name','shipping_address','shipping_zip','shipping_city','customer_phone','customer_email', 'graveyard'];
        let requiredFieldsBilling = ['billing_name', 'billing_phone', 'billing_email', 'billing_address', 'billing_zip', 'billing_city'];
        this.checkErrors(requiredFields);

        if (!this.value.billing_same_as_customer) {
          this.checkErrors(requiredFieldsBilling);
        }
      }
  },
  data () {
    return {
      images: [],
      display_images: [],
      upload_images: [],
      existing_images: [],
      images_to_delete: [],
      image_readers: [],
      display_image_readers: [],
      base64_images: []
    }
  },
  methods: {
    checkErrors(fields) {
      fields.forEach((field) => {
        let element = document.getElementById('warning_' + field);

        if (this.errors.includes(field)) {
          element.classList.add("active");
        } else {
          element.classList.remove("active");
        }
      })
    },
    uploadImage(e) {
      console.log(e);
      let image = e.target.files[0];
        if (image.size < 2000000) {
          let image_reader = new FileReader();
          image_reader.onloadend = (e) => {
              let fileData = image_reader.result;
              let base64String = image_reader.result.replace("data:", "").replace(/^.+,/, "");
              this.base64_images.push({
                'name': image.name,
                'src': fileData,
                'base64': base64String,
                'mimetype': image.type
              });
              console.log(base64String);
              this.display_images.push({
                'name': image.name,
                'src': fileData,
              });
          this.setImages(this.base64_images);

          }
          image_reader.readAsDataURL(image);
          this.display_image_readers.push(image_reader);
          console.log(image);
          this.upload_images.push(image);
          // this.setImages(this.upload_images);
          jQuery('#warning_images').hide();
        } else {
          jQuery('#warning_images').show();
        }
    },
    deleteImage(image) {
      let indexUpload = this.upload_images.findIndex((i) => i.name === image.name );
      let indexDisplay = this.display_images.findIndex((i) => i.name === image.name );
      let indexBase64 = this.base64_images.findIndex((i) => i.name === image.name );


      this.upload_images.splice(indexUpload, 1);
      this.display_images.splice(indexDisplay, 1);
      this.base64_images.splice(indexBase64, 1);

      this.setImages(this.base64_images);
    }

  // },

    // validEmail: function (email) {
    //   var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    //   return re.test(email);
    // }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .design-choice {
    min-height: 400px;
  }

  .uploading-image{
    display:flex;
  }

  .preview-image {
    width: 33%;
  }

  .selected-images-container {
    display:flex;

  }

  .selected-images-container .image-container {
    width: 33.3%;
    position: relative;
    height: fit-content;
    border: 1px solid transparent;
    transition: 0.1s all;
  }

  .selected-images-container .image-container:hover {
    background: #ffffff4a;
    border: 1px solid #e9e9e9;
  }

  .selected-images-container img {
    padding: 1rem;
    max-width: 100%;
    max-height: 100%;
  }

  .close {
    position: absolute;
    font-size: 2rem;
    top: 10px;
    left: 10px;
    color: red;
    transition: 0.1s all;
  }

  .close:hover {
    opacity: 0.5;
  }

  .close:after {
    cursor: pointer;
    display: inline-block;
    content: "\00d7"; /* This will render the 'X' */
  }
/*h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}*/
</style>
